import { SUNDAY_OFFERS } from 'Constants/IAP/SundayOffers';
import { IGameState } from 'State/Game/IGameState';
import DateHelper from 'Utility/DateHelper';
import { ISundayOfferData } from './ISundayOfferData';

const EPOCH_FIRST_SUNDAY_OFFSET = 345_600_000;

export function getWeeklySundayOfferData(state: IGameState): ISundayOfferData {
    const weekNumber = DateHelper.weeksSinceEpoch(DateHelper.now, EPOCH_FIRST_SUNDAY_OFFSET);
    // Get offers and filter for valid ones
    const offers = Object.values<ISundayOfferData>(SUNDAY_OFFERS).filter(offer => offer.condition(state));
    const offerIndex = weekNumber % offers.length;
    return offers[offerIndex];
}
